import {AppThemeProvider} from './theme/AppThemeProvider'
import {TIMER_FIT_MEDIA} from './theme/feltTheme'
import AppLayout from './AppLayout'
import type {AuthUser, Schedule} from './types/domain'
import React, {useEffect, useState} from 'react'
import BlindsTimer from './timer/BlindsTimer'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import {Alert, Button, Snackbar} from '@mui/material'
import {AuthContext} from './auth/AuthContext'
import {useApplicationServices} from './backend/ApplicationServicesContext'
import {createBrowserRouter, RouterProvider} from 'react-router-dom'
import ErrorPage from './ErrorPage'
import PayoutsRoute from './payouts/PayoutsRoute'
import BlindsScheduleRoute from './schedule/BlindsScheduleRoute'
import BlindsSchedulesRoute from './schedule/BlindsSchedulesRoute'
import {ScheduleContext} from './schedule/ScheduleContext'
import defaultSchedule from './blindsupervision-ed_2023-10-21-export.json'
import {SessionCoordinator} from './session/SessionCoordinator'
import SessionsRoute from './session/SessionsRoute'

const HomeRoute = () => (
  <>
    <Stack id="blindsSchedule" sx={{[TIMER_FIT_MEDIA]: {height: '100%'}}}>
      <BlindsTimer/>
    </Stack>
  </>
)

const router = createBrowserRouter([{element: <AppLayout/>, errorElement: <ErrorPage/>, children: [
  {
    path: '/',
    errorElement: <ErrorPage/>,
    element: <HomeRoute/>
  },
  {
    path: '/payouts',
    errorElement: <ErrorPage/>,
    element: <PayoutsRoute/>
  },
  {
    path: '/schedules',
    errorElement: <ErrorPage/>,
    element: <BlindsSchedulesRoute/>
  },
  {
    path: '/schedules/:scheduleId',
    errorElement: <ErrorPage/>,
    element: <BlindsScheduleRoute/>
  },
  {
    path: '/sessions',
    errorElement: <ErrorPage/>,
    element: <SessionsRoute/>
  },
]}])
function App() {
  const {authService, scheduleRepository} = useApplicationServices()
  const [currentUser, setCurrentUser] = useState<AuthUser | null>(null)
  const [scheduleError, setScheduleError] = useState(false)
  const [schedules, setSchedules] = useState<Schedule[]>([])
  const updateSchedules = async() => {
    const userSchedules = await scheduleRepository.getSchedules()
    if (userSchedules?.length) {
      setSchedules(userSchedules)

    } else {
      setSchedules([defaultSchedule])
    }
    setScheduleError(false)
  }
  useEffect(() => {
    return authService.subscribe(setCurrentUser)
  }, [authService])

  useEffect(() => {
    if (currentUser) {
      updateSchedules().catch(() => setScheduleError(true))
    } else {
      setSchedules([])
      setScheduleError(false)
    }
  }, [currentUser])

  return (
    <AppThemeProvider>
      <Box sx={{display: 'flex'}}>
        <AuthContext.Provider value={{currentUser}}>
          <ScheduleContext.Provider value={{schedules, updateSchedules}}>
            <SessionCoordinator uid={currentUser?.uid ?? null}><RouterProvider router={router}/></SessionCoordinator>
            <Snackbar open={scheduleError}>
              <Alert severity="error" action={<Button color="inherit" onClick={() => updateSchedules().catch(() => setScheduleError(true))}>Retry</Button>}>
                Unable to load schedules. Please try again.
              </Alert>
            </Snackbar>
          </ScheduleContext.Provider>
        </AuthContext.Provider>
      </Box>
    </AppThemeProvider>
  )
}

export default App
